<!--
 * @Date: 2020-09-01 09:42:44
 * @Author: MX
 * @LastEditTime: 2020-09-23 14:18:07
 * @Description: API文档
-->
<template>
  <div class="apiDoc main-wrap">
    <div class="apiDoc-wrap">
      <div class="main-left">
        <my-menu></my-menu>
      </div>
      <div class="main-right">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
//json高亮组件
import "../../components/highLight";
//菜单组件
import myMenu from "./menu";
export default {
  name: "ApiDoc",
  components: { myMenu },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.apiDoc {
  background: #f4f5f7;
  height: auto;
  min-height: 100%;
}
.apiDoc-wrap {
  max-width: 1200px;
  width: 100%;
  padding: 20px 0;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  .main-left {
    width: 264px;
    box-sizing: border-box;
    margin-right: 20px;
    // background: #fff;
    height: 100%;
    min-width: 264px;
    border-radius: 10px;
    overflow: hidden;
  }
  .main-right {
    flex: 1;
    background: #fff;
    box-sizing: border-box;
    border-radius: 10px;
  }
}
[dir="rtl"] .apiDoc {
  .main-left {
    margin-left: 20px;
    margin-right: 0;
  }
  ::v-deep .online_doc .online_doc_item_top {
    i {
      margin-left: 20px;
      margin-right: 0;
    }
  }
}
</style>
